import React, { useEffect, useState} from "react";

import {Http} from "../utils/http";

declare const window: any;
declare const AppConfig: any;

type ReCaptchaProps = {
  context: any;
  onSuccess?: () => void;
};
export const ReCaptcha: React.FC<ReCaptchaProps> = ({ context, onSuccess }) => {
  const [script, setScript]: [any, any] = useState(undefined);
  const [elementId] = useState("grecaptcha_" + Math.floor((Math.random() * 100000000)));

  const recaptchaRequired =  context.captchaVerified !== null && !context.user && !context.captchaVerified;

  useEffect(() => {
        if (recaptchaRequired) {
          loadScript();
        }

        return () => {
          if (script) {
            document.body.removeChild(script);
          }
        }
      },
      [recaptchaRequired]);

  const renderRecaptchaWidgets = () => {
    window.recaptchaRenderCallbacks.forEach((callback: any) => {
      callback();
    });

    window.recaptchaRenderCallbacks = [];
  };

  const loadScript = (): void => {
    if (window.grecaptcha !== undefined) {
      renderRecaptcha();
      return;
    }
    window.recaptchaRenderCallbacks = window.recaptchaRenderCallbacks || [];
    window.captchaOnLoad = renderRecaptchaWidgets;
    window.recaptchaRenderCallbacks.push(renderRecaptcha);

    const url = AppConfig.recaptcha_url;
    const queryString = AppConfig.recaptcha_params;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url + queryString;
    script.async = true;
    script.defer = true;
    script.nonce = window.__CSP_NONCE;

    setScript(document.body.appendChild(script));
  };

  const onVerified = (token: string) => {
    Http.get().verifyCaptcha(token).then(() => {
      context.setCaptchaVerified(true);
      onSuccess ? onSuccess() : null;
    }, () => {
      context.setCaptchaVerified(false);
    });
  };

  const renderRecaptcha = (): void => {
    window.grecaptcha.render(
        elementId,
        {
          'sitekey': AppConfig.recaptcha_site_key,
          'callback': onVerified,
        }
    );
  };

  if (!recaptchaRequired) {
    return <></>;
  }

  return (
      <>
        <div id={elementId} />
        <div>
          <small className="text-muted">Captcha required as not logged in</small>
        </div>
      </>
  );
};